import DropdownOptionItem from "../ui/dropdown-option-item";
import DynamicIcon from "../ui/dynamic-icon";
import icon from "../ui/icon";
import SearchItem from "../ui/search-item";
import SearchModalSection from "../ui/search-modal-section";
import SearchModal from "./search-modal";
import { useRouter } from "next/router";
import { useContext, useState } from "react";
import { useTranslations } from "next-intl";
import BusinessContext from "../../contexts/business-context";
import TableContext from "../../contexts/table-context";
import CreateFolderModal from "../ui/create-folder-modal";

const GeneralSearchModal = ({ toggleModal, isOpen }) => {
  const router = useRouter();
  const { activeBusiness } = useContext(BusinessContext);
  const { tables, createTable } = useContext(TableContext);
  const [isCreateFolderOpen, setIsCreateFolderOpen] = useState(false);
  const [query, setQuery] = useState('');
  const t = useTranslations('generalSearch');

  const onSearchChange = (value) => {
    setQuery(value);
  }

  const closeModal =() => {
    setQuery('');
    toggleModal();
  }

  const toggleCreateFolder = () => {
    setIsCreateFolderOpen(prev => !prev);
  }

  const smartPrompts = [
    t('prompts.summarizeMarketing'),
    t('prompts.reviewTasks'),
    t('prompts.tasksAssignedToMe'),
    t('prompts.whatsToday')
  ]

  const navigations = [
    { name: t('goToHome'), url: `/${router.query.uuid}/home` },
    { name: t('goToSettings'), url: `/${router.query.uuid}/manage-people` },
    { name: t('reportABug'), url: "https://forms.gle/rqLWcSkrpiNouynD8" }
  ]

  const handlePromptClick = (prompt) => {
    const businessUuid = activeBusiness?.uuid || router.query.uuid;
    router.push({
      pathname: `/${businessUuid}/chats/new`,
      query: { prompt: prompt }
    });
    closeModal();
  };

  const handleAskAi = (query) => {
    const businessUuid = activeBusiness?.uuid || router.query.uuid;
    router.push({
      pathname: `/${businessUuid}/chats/new`,
      query: { prompt: query }
    });
    closeModal();
  };

  const onCreateFolder = (name, extraCallback) => {

    const callBack = () => {
      if (extraCallback) {
        extraCallback();
      }
    }

    createTable('folder', name, callBack, 'private');
  }

  const filteredTables = tables?.filter(table => table.name.toLowerCase().includes(query.toLowerCase()));

  return (
    <>
      <SearchModal toggleModal={toggleModal} isOpen={isOpen} onAskAi={handleAskAi} onSearchChange={onSearchChange}>
        <div className="grid gap-[8px] px-[8px] h-[439px] content-start custom-scrollbar">
          {(filteredTables?.length > 0 && query !== '') ? (
            filteredTables.map(table => (
              <DropdownOptionItem key={table.uuid} icon={table?.metadata?.render_types?.[0]?.type === 'document' ? 'file' : 'table'} onClick={() => { router.push(`/${router.query.uuid}/t/${table.uuid}`); closeModal(); }} iconColor="custom-text-grey-200">
                {table.name}
              </DropdownOptionItem>
            ))
          ) : (
            <>
              <SearchModalSection title={t('actions')} titleClass='!px-[8px]'>
                <div className="grid">
                 {query !== '' && <DropdownOptionItem icon='sparkles' onClick={() => { handleAskAi(query); }}>{t('askAi')} &quot;{ query }&quot;</DropdownOptionItem>}
                  <DropdownOptionItem icon='file' onClick={() => { createTable('document', null, closeModal()); }}>{t('newPage')}</DropdownOptionItem>
                  <DropdownOptionItem icon='folder-closed' onClick={() => { toggleCreateFolder(); toggleModal(); }}>{t('createFolder')}</DropdownOptionItem>
                </div>
              </SearchModalSection>
              <SearchModalSection title={t('smartPrompts')} titleClass='!px-[8px]'>
                <div className="grid">
                  {smartPrompts.map(prompt => (
                    <DropdownOptionItem
                      icon="sparkles"
                      iconColor="custom-text-grey-200"
                      key={prompt}
                      onClick={() => handlePromptClick(prompt)}
                    >
                      {prompt}
                    </DropdownOptionItem>
                  ))}
                </div>
              </SearchModalSection>
              <SearchModalSection title={t('navigations')} titleClass='!px-[8px]'>
                <div className="grid">
                  {navigations.map(nav => (
                    <DropdownOptionItem icon="arrow-right" onClick={() => { router.push(nav.url); closeModal(); }} iconColor="custom-text-grey-200" key={nav.name}>{nav.name}</DropdownOptionItem>
                  ))}
                </div>
              </SearchModalSection>
            </>
          )}
        </div>
      </SearchModal>
      <CreateFolderModal onCreate={onCreateFolder} isModalOpen={isCreateFolderOpen} toggleModal={toggleCreateFolder} />
    </>
  );
}
export default GeneralSearchModal;